module.exports = __webpack_public_path__ + "html/wave-header_c30f496e9fb6d94b4c1436a3f4d102f8.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 118